import { lazy } from 'react';
import Demo from '@/page/demo';
import Detail from '@/page/detail/views/content';
import { ADDRESS_ROUTE } from '@/router/address';

interface IRouterItem {
    path: string;
    component: any;
    exact?: boolean;
}
export const ROUTER: IRouterItem[] = [
    {
        path: '/',
        exact: true,
        component: Detail,
    },
    {
        path: '/resultV2',
        component: lazy(() => import('@/page/resultV2/index')),
    },
    {
        path: '/order-confirm',
        component: lazy(() => import('@/page/orderConfirm/views/orderConfirm')),
    },
    {
        path: '/order-list',
        component: lazy(() => import('@/page/orderList/views/index')),
    },
    {
        path: '/order-detail',
        component: lazy(() => import('@/page/orderDetail/view/index')),
    },
    {
        path: '/detail/:encId',
        component: Detail,
    },
    {
        path: '/guarantee',
        component: lazy(() => import('@/page/guarantee/index')),
    },
    ...ADDRESS_ROUTE,
    {
        path: '/demo',
        component: Demo,
    },
];
